module.exports = __webpack_public_path__ + "static/media/2.8aeb0e46.jpg";